import { render, staticRenderFns } from "./searchData.vue?vue&type=template&id=29cb2880&scoped=true"
import script from "./searchData.vue?vue&type=script&lang=js"
export * from "./searchData.vue?vue&type=script&lang=js"
import style0 from "./searchData.vue?vue&type=style&index=0&id=29cb2880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cb2880",
  null
  
)

export default component.exports